import { useState } from "react";
import {
  ResponseGetOperationLogsResponse,
  ResponseGetOperationLogsResponseFromJSON,
  ResponseGetItemStatusHistoryResponse,
  ResponseGetItemStatusHistoryResponseFromJSON,
} from "../../services/OpenAPI";
import { apiClient } from "./common";

export const useApiGetOperationLogs = () => {
  const [operationLogs, setOperationLogs] = useState<ResponseGetOperationLogsResponse | null>(null);
  const [itemHistory, setItemHistory] = useState<ResponseGetItemStatusHistoryResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchOperationLogs = async (tenantId: number, page = 1, limit = 50) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await apiClient.get("/api/v1/operationLog/getAll", {
        params: { tenantId, page, limit },
        withCredentials: true,
      });
      const data = ResponseGetOperationLogsResponseFromJSON(response.data);
      setOperationLogs(data);
      return data;
    } catch (err) {
      setError("操作ログの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const fetchItemStatusHistory = async (tenantId: number, page = 1, limit = 50) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await apiClient.get("/api/v1/operationLog/itemHistory", {
        params: { tenantId, page, limit },
        withCredentials: true,
      });
      const data = ResponseGetItemStatusHistoryResponseFromJSON(response.data);
      setItemHistory(data);
      return data;
    } catch (err) {
      setError("アイテム遷移履歴の取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { operationLogs, itemHistory, fetchOperationLogs, fetchItemStatusHistory, error, isLoading };
};
